// Static client-side content that does not belong in the DB.
//
// The product catalogue itself is now served from the API (see
// ProductsContext + /api/products). Reviews live here as the fallback
// shown on the homepage marquee until the API returns featured reviews.
// The strength helpers are pure utilities used by ProductCard and
// ProductDetailPage.
//
// The general FAQ list has moved to src/shared/faqs.ts so the server
// can include it in /llms.txt and /llms-full.txt.

import type { Review } from '../types';

export const reviews: Review[] = [
  {
    id: '1',
    name: 'Sneha R.',
    location: 'Pune',
    rating: 5,
    text: 'Studying for CA exams and this helps me stay alert. Clean Mint is perfect - not too strong, not too light.',
    avatar: 'books',
  },
  {
    id: '2',
    name: 'Arjun M.',
    location: 'Mumbai',
    rating: 5,
    text: "Perfect for my gaming sessions! No need to take breaks anymore. The Ice Cool Mint keeps me focused for hours.",
    avatar: 'gaming',
  },
  {
    id: '3',
    name: 'Priya S.',
    location: 'Bangalore',
    rating: 5,
    text: "As a first-timer, I was confused but the quiz helped me pick the right one. Tropical Mix is so smooth!",
    avatar: 'shopping',
  },
  {
    id: '4',
    name: 'Rohan K.',
    location: 'Delhi',
    rating: 5,
    text: "Love that I can use it during parties without stepping out. Fresh breath, no smell - my friends can't even tell!",
    avatar: 'party',
  },
  {
    id: '5',
    name: 'Vikram T.',
    location: 'Chennai',
    rating: 5,
    text: "Switched from cigarettes 3 months ago. ZYN pouches made the transition so easy. Best decision ever!",
    avatar: 'fitness',
  },
  {
    id: '6',
    name: 'Meera D.',
    location: 'Hyderabad',
    rating: 5,
    text: "The delivery was super fast and discreet packaging. VELO Tropical Mango is now my everyday go-to!",
    avatar: 'delivery',
  },
];

export function getStrengthLabel(mg: number): string {
  if (mg <= 4) return 'Light';
  if (mg <= 8) return 'Medium';
  if (mg <= 12) return 'Strong';
  if (mg <= 20) return 'Extra Strong';
  return 'Super Strong';
}

export function getStrengthColor(mg: number): string {
  if (mg <= 4) return '#22c55e';
  if (mg <= 8) return '#eab308';
  if (mg <= 12) return '#f97316';
  if (mg <= 20) return '#ef4444';
  return '#7c2d12';
}
